import { useEffect, useRef } from 'react';

function resizeCanvas(canvas) {
  const { width, height } = canvas.getBoundingClientRect();
  if (canvas.width !== width || canvas.height !== height) {
    const { devicePixelRatio: ratio = 1 } = window;
    const context = canvas.getContext('2d');
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    context.scale(ratio, ratio);
    return true;
  }
  return false;
}

const useConfetti = (draw, finishedb) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    let alpha = 1.0;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    resizeCanvas(canvas);

    let animationFrameId;

    const render = () => {
      if (alpha <= 0) {
         finishedb();
        return;
      }

      context.beginPath();
      context.fillStyle = '#F05F40';
      const { width, height } = context.canvas;
      context.clearRect(0, 0, width, height);
      draw(context, canvas, alpha);
      animationFrameId = window.requestAnimationFrame(render);
      alpha -= 0.01;
    };

    render();

    return () => {
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [draw]);

  return canvasRef;
};

export default useConfetti;
